module.exports = __webpack_public_path__ + "img/banner1.26e004d6.png";